export const CONTENT_VARIANTS = Object.freeze({
    H1_BANNER: {
        id: 'H1_BANNER',
        name: 'H1 Banner',
        thumbnail: 'https://img-cdn.misfitsmarket.com/test/lettuce/Minimap-Thumbnail__Banner-H1__Desktop',
        category: 'banner',
        defaultData: {
            active: false,
            largeImage: '',
            smallImage: '',
            bannerName: '',
            copy: '',
            linkURL: '',
            linkTitle: '',
            sponsoredBrands: [],
            backgroundColor: '#FFFFFF',
        },
    },
    BANNER_CAROUSEL_1: {
        id: 'BANNER_CAROUSEL_1',
        name: 'Banner Carousel 1',
        thumbnail: 'https://img-cdn.misfitsmarket.com/test/lettuce/Minimap-Thumbnail__Banner-Carousel-1__Desktop',
        category: 'banner',
        defaultData: {
            displayType: 'BANNER_CAROUSEL_1',
            name: '',
            items: [],
        },
    },
    BANNER_CAROUSEL_2: {
        id: 'BANNER_CAROUSEL_2',
        name: 'Banner Carousel 2',
        thumbnail: 'https://img-cdn.misfitsmarket.com/test/lettuce/Minimap-Thumbnail__Banner-Carousel-2__Desktop',
        category: 'banner',
        defaultData: {
            displayType: 'BANNER_CAROUSEL_2',
            name: '',
            items: [],
        },
    },
    BANNER_CAROUSEL_3: {
        id: 'BANNER_CAROUSEL_3',
        name: 'Banner Carousel 3',
        thumbnail: 'https://img-cdn.misfitsmarket.com/test/lettuce/Minimap-Thumbnail__Banner-Carousel-3__Desktop',
        category: 'banner',
        defaultData: {
            displayType: 'BANNER_CAROUSEL_3',
            name: '',
            items: [],
        },
    },
    BANNER_1: {
        id: 'BANNER_1',
        name: 'Banner 1',
        thumbnail: 'https://img-cdn.misfitsmarket.com/test/lettuce/Minimap-Thumbnail__Banner-1__Desktop',
        category: 'banner',
        defaultData: {
            displayType: 'BANNER_1',
            name: '',
            items: [
                {
                    bgColor: '#FFFFFF',
                    text: '',
                    imageLeftUrl: '',
                    imageRightUrl: '',
                    linkUrl: '',
                    openLinkInNewTab: true,
                },
            ],
        },
    },
    PRODUCT_SPOTLIGHT: {
        id: 'PRODUCT_SPOTLIGHT',
        name: 'Product Spotlight',
        thumbnail: 'https://img-cdn.misfitsmarket.com/test/lettuce/Minimap-Thumbnail__Product-Spotlight__Desktop',
        category: 'other',
        defaultData: {
            displayType: 'PRODUCT_SPOTLIGHT',
            imageUrl: '',
            name: '',
            description: '',
            linkUrl: '',
            linkText: '',
            items: [],
            bgColor: '#FFFFFF',
        },
    },
    PRODUCT_CAROUSEL_1: {
        id: 'PRODUCT_CAROUSEL_1',
        name: 'Product Carousel 1',
        thumbnail: 'https://img-cdn.misfitsmarket.com/test/lettuce/Minimap-Thumbnail__Product-Carousel-1__Desktop',
        category: 'carousel',
        defaultData: {
            displayType: 'PRODUCT_CAROUSEL_1',
            name: '',
            description: '',
            linkUrl: '',
            linkText: '',
            items: [],
            dynamicAisleType: '',
        },
    },
    PRODUCT_CAROUSEL_2: {
        id: 'PRODUCT_CAROUSEL_2',
        name: 'Product Carousel 2',
        thumbnail: 'https://img-cdn.misfitsmarket.com/test/lettuce/Minimap-Thumbnail__Product-Carousel-2__Desktop',
        category: 'carousel',
        defaultData: {
            displayType: 'PRODUCT_CAROUSEL_2',
            imageUrl: '',
            name: '',
            description: '',
            linkUrl: '',
            linkText: '',
            items: [],
            dynamicAisleType: '',
        },
    },
    PRODUCT_CAROUSEL_3: {
        id: 'PRODUCT_CAROUSEL_3',
        name: 'Product Carousel 3',
        thumbnail: 'https://img-cdn.misfitsmarket.com/test/lettuce/Minimap-Thumbnail__Product-Carousel-3__Desktop',
        category: 'carousel',
        defaultData: {
            displayType: 'PRODUCT_CAROUSEL_3',
            imageUrl: '',
            name: '',
            description: '',
            linkUrl: '',
            linkText: '',
            items: [],
            dynamicAisleType: '',
        },
    },
});

export const CONTENT_VARIANT_CATEGORIES = Object.freeze({
    banner: {
        name: 'Banners',
        variants: ['H1_BANNER', 'BANNER_1', 'BANNER_CAROUSEL_1', 'BANNER_CAROUSEL_2', 'BANNER_CAROUSEL_3'],
    },
    carousel: {
        name: 'Carousels',
        variants: ['PRODUCT_CAROUSEL_1', 'PRODUCT_CAROUSEL_2', 'PRODUCT_CAROUSEL_3'],
    },
    other: {
        name: 'Other',
        variants: ['PRODUCT_SPOTLIGHT'],
    },
});

export const TOAST_ERROR_STYLE = {
    backgroundColor: '#dc2626',
    color: 'white',
    border: '1px solid #b91c1c',
};
